import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, CheckIcon, MailIcon } from 'lucide-react';
import { ProjectCarousel } from '../components/ProjectCarousel';
export function UXUIDesign() {
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-2341">
      {/* Header */}
      <header className="py-4 px-6 bg-white border-b border-stone-200" data-id="element-2342">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-2343">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-2344">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-2345" />
            <span className="font-light" data-id="element-2346">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-2347">Maria Elina</h1>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-10 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-2348">
        <div className="max-w-7xl mx-auto text-center" data-id="element-2349">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-2350">
            <h2 className="text-5xl md:text-7xl font-light text-stone-900 mb-4 flex flex-col items-center gap-2" data-id="element-2351">
              <img src="https://storage.yandexcloud.net/maria-images/images/UI.svg" alt="UX/UI Design" className="md:w-16 md:h-16 w-10 h-10" data-id="element-2352" />
              UX/UI Design
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-2xl mx-auto" data-id="element-2353">
              Human-centered digital experiences that blend aesthetics with
              intuitive interaction
            </p>
          </motion.div>
        </div>
      </section>

      {/* Service Packages Section */}
      <section className="py-20 px-6 pt-[40px]" data-id="element-2354">
        <div className="max-w-7xl mx-auto" data-id="element-2355">
          {/* Section Header */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-16" data-id="element-2356">
            <div className="relative inline-block" data-id="element-2357">
              <h3 className="text-4xl md:text-5xl font-extralight text-stone-900 mb-6 tracking-tight" data-id="element-2358">
                Service Packages
              </h3>
              <motion.div initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.2
            }} className="absolute -bottom-2 left-0 right-0 h-[2px] bg-emerald-600" style={{
              clipPath: 'polygon(10% 0, 90% 0, 100% 100%, 0 100%)'
            }} data-id="element-2359" />
            </div>
          </motion.div>

          {/* Full Package - Featured */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} whileHover={{
          y: -8
        }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 mb-8" style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
        }} data-id="element-2360">
            {/* Holographic gradient background */}
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/15 via-teal-400/15 to-cyan-400/15" data-id="element-2361" />
            <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-2362" />

            {/* Featured badge */}
            <div className="absolute top-3 right-3 md:top-6 md:right-6" data-id="element-2363">
              <span className="inline-block px-2.5 py-1 text-xs md:px-4 md:py-1.5 md:text-sm font-light text-emerald-700 bg-emerald-100 rounded-full border border-emerald-200" data-id="element-2364">
                Complete Solution
              </span>
            </div>

            <div className="relative z-10 p-10" data-id="element-2365">
              <h4 className="text-3xl font-light text-stone-900 mb-8 tracking-tight" data-id="element-2366">
                Full Package
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-2367">
                {/* Column 1 */}
                <div data-id="element-2368">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-2369">
                    UX Research & Strategy
                  </h5>
                  <ul className="space-y-3" data-id="element-2370">
                    <li className="flex items-start gap-3" data-id="element-2371">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2372" />
                      <span className="text-stone-700 font-light" data-id="element-2373">
                        User research & interviews
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2374">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2375" />
                      <span className="text-stone-700 font-light" data-id="element-2376">
                        Competitor assessment
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2377">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2378" />
                      <span className="text-stone-700 font-light" data-id="element-2379">
                        User flows & journey mapping
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2380">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2381" />
                      <span className="text-stone-700 font-light" data-id="element-2382">
                        Wireframing & prototyping
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Column 2 */}
                <div data-id="element-2383">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-2384">
                    UI Design & Delivery
                  </h5>
                  <ul className="space-y-3" data-id="element-2385">
                    <li className="flex items-start gap-3" data-id="element-2386">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2387" />
                      <span className="text-stone-700 font-light" data-id="element-2388">
                        Visual design & design system
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2389">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2390" />
                      <span className="text-stone-700 font-light" data-id="element-2391">
                        Mobile & desktop optimization
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2392">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2393" />
                      <span className="text-stone-700 font-light" data-id="element-2394">
                        Development in web builder
                      </span>
                    </li>
                    <li className="flex items-center gap-3 py-1" data-id="element-2395">
                      <span className="text-stone-400 font-light italic text-sm pl-8" data-id="element-2396">
                        OR
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2397">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2398" />
                      <span className="text-stone-700 font-light" data-id="element-2399">
                        Pure design handoff package
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Enquire Button */}
              <div className="mt-10" data-id="element-2400">
                <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Full%20Package%20%E2%80%93%20UX%2FUI%20Design&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Full%20Package%20for%20UX%2FUI%20Design%2C%20which%20includes%3A%0D%0A%0D%0AUX%20Research%20%26%20Strategy%3A%0D%0A%E2%80%A2%20User%20research%20%26%20interviews%0D%0A%E2%80%A2%20Competitor%20assessment%0D%0A%E2%80%A2%20User%20flows%20%26%20journey%20mapping%0D%0A%E2%80%A2%20Wireframing%20%26%20prototyping%0D%0A%0D%0AUI%20Design%20%26%20Delivery%3A%0D%0A%E2%80%A2%20Visual%20design%20%26%20design%20system%0D%0A%E2%80%A2%20Mobile%20%26%20desktop%20optimization%0D%0A%E2%80%A2%20Development%20in%20web%20builder%20OR%20Pure%20design%20handoff%20package%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                y: -3
              }} className="group/btn inline-block relative" data-id="element-2401">
                  <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                  clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                }} data-id="element-2402" />
                  <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
                  clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                }} data-id="element-2403">
                    <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-2404" />
                    <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-2405">
                      <MailIcon className="w-4 h-4" data-id="element-2406" />
                      Enquire
                    </span>
                  </div>
                </motion.a>
              </div>
            </div>

            {/* Angular corner accents */}
            <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2407" />
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2408" />
          </motion.div>

          {/* Other Packages Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2409">
            {/* UX Package */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-2410">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-2411" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-2412" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-2413">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-2414">
                  UX Package
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-2415">
                  <li className="flex items-start gap-3" data-id="element-2416">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2417" />
                    <span className="text-stone-700 font-light" data-id="element-2418">
                      User research
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2419">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2420" />
                    <span className="text-stone-700 font-light" data-id="element-2421">
                      Personas & user journeys
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2422">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2423" />
                    <span className="text-stone-700 font-light" data-id="element-2424">
                      Information architecture
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2425">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2426" />
                    <span className="text-stone-700 font-light" data-id="element-2427">
                      Wireframing
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-2428">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20UX%20Package&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20UX%20Package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20User%20research%0D%0A%E2%80%A2%20Personas%20%26%20user%20journeys%0D%0A%E2%80%A2%20Information%20architecture%0D%0A%E2%80%A2%20Wireframing%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-2429">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-2430" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-2431">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-2432" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-2433">
                        <MailIcon className="w-4 h-4" data-id="element-2434" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2435" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2436" />
            </motion.div>

            {/* UI Package */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-2437">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-2438" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-2439" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-2440">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-2441">
                  UI Package
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-2442">
                  <li className="flex items-start gap-3" data-id="element-2443">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2444" />
                    <span className="text-stone-700 font-light" data-id="element-2445">
                      Visual design
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2446">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2447" />
                    <span className="text-stone-700 font-light" data-id="element-2448">
                      Component library
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2449">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2450" />
                    <span className="text-stone-700 font-light" data-id="element-2451">
                      Responsive layouts
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2452">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2453" />
                    <span className="text-stone-700 font-light" data-id="element-2454">
                      Prototyping
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2455">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2456" />
                    <span className="text-stone-700 font-light" data-id="element-2457">
                      Developer handoff
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-2458">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20UI%20Package&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20UI%20Package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Visual%20design%0D%0A%E2%80%A2%20Component%20library%0D%0A%E2%80%A2%20Responsive%20layouts%0D%0A%E2%80%A2%20Prototyping%0D%0A%E2%80%A2%20Developer%20handoff%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-2459">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-2460" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-2461">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-2462" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-2463">
                        <MailIcon className="w-4 h-4" data-id="element-2464" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2465" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2466" />
            </motion.div>

            {/* UX Audit */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-2467">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-2468" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-2469" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-2470">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-2471">
                  UX Audit
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-2472">
                  <li className="flex items-start gap-3" data-id="element-2473">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2474" />
                    <span className="text-stone-700 font-light" data-id="element-2475">
                      Heuristic evaluation
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2476">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2477" />
                    <span className="text-stone-700 font-light" data-id="element-2478">
                      Usability assessment
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2479">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2480" />
                    <span className="text-stone-700 font-light" data-id="element-2481">
                      Competitor analysis
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2482">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2483" />
                    <span className="text-stone-700 font-light" data-id="element-2484">
                      Recommendations report
                    </span>
                  </li>
                </ul>
                <p className="text-sm text-stone-500 font-light mt-4 italic" data-id="element-2485">
                  *Based on existing product
                </p>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-2486">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20UX%20Audit&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20UX%20Audit%20package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Heuristic%20evaluation%0D%0A%E2%80%A2%20Usability%20assessment%0D%0A%E2%80%A2%20Competitor%20analysis%0D%0A%E2%80%A2%20Recommendations%20report%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-2487">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-2488" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-2489">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-2490" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-2491">
                        <MailIcon className="w-4 h-4" data-id="element-2492" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2493" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2494" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Work Samples Section */}
      <section className="py-24 px-6 bg-white border-t border-stone-100" data-id="element-2495">
        <div className="max-w-7xl mx-auto" data-id="element-2496">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-20" data-id="element-2497">
            <h3 className="text-4xl md:text-5xl font-extralight text-stone-900 mb-6 tracking-tight" data-id="element-2498">
              Work Samples
            </h3>
            <div className="w-24 h-[1px] bg-emerald-600 mx-auto" data-id="element-2499" />
          </motion.div>

          {/* Project 1: BioMaxing */}
          <div className="mb-32" data-id="element-2500">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-12" data-id="element-2501">
              <h4 className="text-3xl md:text-4xl font-light text-stone-900 mb-3" data-id="element-2502">
                BioMaxing
              </h4>
              <p className="text-emerald-700 font-medium mb-6 tracking-wide uppercase text-sm" data-id="element-2503">
                Full UX/UI Package
              </p>
              <p className="text-lg text-stone-600 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-2504">
                BioMaxing is a multi-platform biohacking application spanning
                Web, Mobile and Telegram, designed to make wellness tracking
                intuitive and engaging.
              </p>
            </motion.div>

            <ProjectCarousel slides={[{
            image: 'https://storage.yandexcloud.net/maria-images/images/Web%20final%20design%20bio.png',
            caption: 'Web Layouts'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Mob%20bio%20initial.png',
            caption: 'Initial Mobile App Design'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Initial%20design%20bio.png',
            caption: 'Initial Website UI'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/UI%20ideation%20bio.png',
            caption: 'UX/UI Research and Wireframing'
          }]} data-id="element-2505" />
          </div>

          {/* Project 2: Co-Lab */}
          <div data-id="element-2506">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-12" data-id="element-2507">
              <h4 className="text-3xl md:text-4xl font-light text-stone-900 mb-3" data-id="element-2508">
                Co-Lab
              </h4>
              <p className="text-emerald-700 font-medium mb-6 tracking-wide uppercase text-sm" data-id="element-2509">
                UX Research & UI Design
              </p>
              <p className="text-lg text-stone-600 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-2510">
                Co-Lab is an innovative beauty and wellness digital marketplace
                with immersive 3D experiences and gamified engagement.
              </p>
            </motion.div>

            <ProjectCarousel slides={[{
            image: 'https://storage.yandexcloud.net/maria-images/images/3D%20environment.png',
            caption: '3D Experience Design'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Product%20page%20path.png',
            caption: 'Product Page UX/UI'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Telegram%20miniapp.png',
            caption: 'Telegram MiniApp UX/UI'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/metaverse%20UX%20planning.png',
            caption: 'Metaverse UX Planning'
          }]} data-id="element-2511" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-t from-emerald-50/40 via-stone-50 to-stone-50 border-t border-emerald-600/30" data-id="element-2512">
        <div className="max-w-4xl mx-auto text-center" data-id="element-2513">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-2514">
            <h2 className="text-4xl md:text-5xl font-light mb-6 text-stone-900" data-id="element-2515">
              Have a specific request?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-2516">
              Let's discuss what we can create together
            </p>
            <motion.a href="mailto:contact@maria-elina.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-2517">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-2518" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-2519">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-2520" />
                <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-2521">
                  <MailIcon className="w-4 h-4" data-id="element-2522" />
                  Get in Touch
                </span>
              </div>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>;
}